export default __webpack_public_path__ + "static/media/rightarrow.45780520.svg";